<template>
    <v-dialog v-model="dialog" max-width="500px" persistent>
        <v-card elevation="0">
            <v-card-title class="text-subtitle-1">
                <v-icon small class="pr-2" >mdi-tag-outline</v-icon>
                Adicionar Deficiências
                <v-spacer></v-spacer>
                <!-- <v-btn 
                    class="grey lighten-1 black--text"
                    rounded
                    elevation="0"
                    left
                    @click="close"
                ><v-icon small left>mdi-close-box-outline</v-icon>Fechar</v-btn> -->
            </v-card-title>

            <v-card-text>
                <p class="ma-2 text-sm-body-2">
                    <v-chip-group 
                        column 
                        multiple>
                        <v-chip
                            label
                            outlined
                            v-for="def in listDeficiencia" :key="def.DeficienciaId"
                            @click="addDisability(def.DeficienciaId, def.DescricaoDefiencia, def.AfetaMobilidade)">
                        {{ def.DescricaoDefiencia }}
                        </v-chip>
                    </v-chip-group>
                    
                </p>
             </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn
                    elevation="0"
                    color="secondary"
                    small
                    outlined
                    rounded 
                    @click="close">
                    <v-icon left>mdi-close</v-icon>
                Fechar
                </v-btn>
            </v-card-actions>
            <modalAffect ref="mdAffect" :dialog.sync="showModalAffect" />
            <snackbar
                :text="snackbarMessage"
                :color="snackbarColor"
            />
        </v-card>
    </v-dialog>
</template>
<script>
import snackbarMixin from "@/mixins/snackbar.mixin";
import { mapGetters } from 'vuex';
import ConfirmAffect from './ConfirmMobilityAffected.vue';

export default {
    mixins: [snackbarMixin],
    props:{
        dialog:{
            default:false
        }
    },
    components: {
        "modalAffect": ConfirmAffect,
    },
    watch:{},
    mounted() {},
    data(){
        return {
            listDisabilitySelected:[],
            showModalAffect: false,
        }
    },
    methods: {
        close(){
            this.$emit('update:dialog', false)
        },
        clear(){},
        
        addDisability(id, text, affect){
            // console.log('Pg AddDiability - Passo 1');
            // console.log(this.listDisabilitySelected);
            let tagFind = this.listDisabilitySelected.map(e=>e.DeficienciaId).indexOf(id);

            if(tagFind == -1) {
                let newDisability = {DeficienciaId:id, DescricaoDefiencia:text, AfetaMobilidade: ((this.isNullOrEmpty(affect)) ? false : affect)};

                this.$refs.mdAffect.loadDisabilityRequest(newDisability, this.listDisabilitySelected);
                this.$refs.mdAffect.showModalAffect(true);
             } else {
                 this.showSnackbar('Item já adicionado!', 'error');
             }
        },
        alertaGeral(valor){
            alert(valor);
        },        
        loadDisabilityRequest(item){
            //recebe os itens vindo da tela origem e atribui seu valor à variavel
            this.listDisabilitySelected = item;
        },
        isNullOrEmpty(value){
            return (value == undefined || value == null || value == "" || value.length == 0);
        },
    },
    computed: {
        ...mapGetters('lists',['listDeficiencia']),
    }

}
</script>
<style scoped>

</style>